const BASE = 'https://edlenimages.edlen.com';

const FILE = {
  FAQ: [BASE, 'FAQ'].join('/'),
};

export default FILE;
